import { Box, Flex, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconArrowLeft } from 'assets/icons';
import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import Configuration from 'containers/Integrations/Pimsy/Configuration';
import GeneralInfo from 'containers/Integrations/Pimsy/GeneralInfo';
import { useIntegrationStore } from 'store/useIntegrationStore';

const Pimsy: React.FC<unknown> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['integrations']);
  const tabHeaders = [{ label: t('integrations:generalInfo') }, { label: t('integrations:configuration') }];
  const tabPanels = [{ panel: <GeneralInfo /> }, { panel: <Configuration /> }];

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const pimsyIntegrationData = integrationListData.filter((tab: any) => tab.key === 'pimsy')[0];

  return (
    <Flex flexDirection="column" padding="28px 20px 28px 20px">
      <Flex flexDirection="row" alignContent="center" maxWidth="300px" mb={12}>
        <IconButton
          aria-label="back"
          as={IconArrowLeft}
          variant="ghost"
          p="2"
          cursor="pointer"
          mt="1"
          size="sm"
          sx={{ '& path': { fill: 'black' } }}
          onClick={() => navigate(-1)}
        ></IconButton>
        <Box mt={3} width="100px">
          <img src={pimsyIntegrationData.image} alt="App Logo" />
        </Box>
      </Flex>
      <Tabs>
        <TabHeader tabHeaders={tabHeaders} />
        <TabPanels tabPanels={tabPanels} />
      </Tabs>
    </Flex>
  );
};

export default Pimsy;
